/**
 *
 * @module LoggerConfiguration
 *
 */

/**
 *
 * @class LoggerConfiguration
 *
 */
export default class LoggerConfiguration {

    /**
     *
     * @param {ConsoleSinkConfiguration} [console=null]
     * @param {SDK.Logging.LoggingClientConfiguration} [loggingClientConfiguration=null]
     *
     */
    constructor(console, loggingClientConfiguration) {

        /**
         *
         * @access public
         * @type {ConsoleSinkConfiguration}
         *
         */
        this.console = console;

        /**
         *
         * @access public
         * @type {LoggingClientConfiguration}
         *
         */
        this.client = loggingClientConfiguration;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/loggerConfiguration.js